// Correspond à App\Enum\TrainingSkill\StatusEnum côté back (src/Enum/TrainingSkill/StatusEnum.php).
export const contractMissionStatusConstante = Object.freeze({
  SUGGESTED: 1,
  INTEGRATED: 2,
  REFUSED: 3,
  ATTENTE_SUGGESTED: 4,
  ARCHIVED: 5,
});

// Champs de date utilisés par QuestionnaireFilterBlockComponent pour trier les missions
// (partagé entre QuestionnaireMissionComponent et TriadDashboardMissionTabComponent).
export const missionSortConstante = Object.freeze({
  START_DATE: "startDate",
  END_DATE: "endDate",
});
